"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserDefaults = void 0;
var react_1 = require("react");
var CognitoSyncContextProvider_1 = require("../CognitoSyncContextProvider");
var CognitoSyncManager_1 = __importDefault(require("../models/CognitoSyncManager"));
function useUserDefaults(key, defaultValue, options) {
    var _this = this;
    var dataset = (options === null || options === void 0 ? void 0 : options.dataset) || "UserDefaults";
    var client = (0, react_1.useContext)(CognitoSyncContextProvider_1.CognitoSyncContext).client;
    var _a = (0, react_1.useState)(function () {
        return transform(CognitoSyncManager_1.default.getLocalStorage(dataset, key), options === null || options === void 0 ? void 0 : options.typeGuard) || defaultValue;
    }), data = _a[0], setData = _a[1];
    var _b = (0, react_1.useState)(true), loading = _b[0], setLoading = _b[1];
    var _c = (0, react_1.useState)(), error = _c[0], setError = _c[1];
    var handleError = function (error) { return setError(error); };
    var setDataWithType = (0, react_1.useCallback)(function (value) {
        setData(transform(value, options === null || options === void 0 ? void 0 : options.typeGuard) || defaultValue);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setData]);
    (0, react_1.useEffect)(function () {
        setLoading(true);
        var setValue = function (value, isCurrentlyLocalState) {
            if (isCurrentlyLocalState === void 0) { isCurrentlyLocalState = false; }
            setLoading(isCurrentlyLocalState);
            setDataWithType(value);
        };
        client === null || client === void 0 ? void 0 : client.get(dataset, key).then(function (data) {
            setValue(data);
        }).catch(handleError);
        client === null || client === void 0 ? void 0 : client.addListener(dataset, key, setValue);
        return function () {
            client === null || client === void 0 ? void 0 : client.removeListener(dataset, key, setValue);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [client, key, dataset, setDataWithType]);
    var setNewValue = function (newValue) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setLoading(true);
            setData(newValue);
            client === null || client === void 0 ? void 0 : client.updateRecord(dataset, key, JSON.stringify(newValue)).catch(handleError);
            return [2 /*return*/];
        });
    }); };
    return [data, setNewValue, { loading: loading, error: error }];
}
exports.useUserDefaults = useUserDefaults;
function transform(value, typeGuard) {
    if (value) {
        try {
            var output = JSON.parse(value);
            if (typeGuard) {
                if (typeGuard(output)) {
                    return output;
                }
                return undefined;
            }
            else {
                return output;
            }
        }
        catch (error) {
            console.error("Transform not possible for", value);
        }
    }
    return undefined;
}
//# sourceMappingURL=useUserDefaults.js.map